import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCardAspectRatioMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  cardAspectRatio?: Types.InputMaybe<Types.AssetAggregateCardAspectRatioEnum>;
}>;


export type UpdateShareCardAspectRatioMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardAspectRatio: Types.AssetAggregateCardAspectRatioEnum } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardAspectRatio: Types.AssetAggregateCardAspectRatioEnum } } | null } | null };


export const UpdateShareCardAspectRatio = /*#__PURE__*/ gql`
    mutation UpdateShareCardAspectRatio($shareId: ID!, $cardAspectRatio: AssetAggregateCardAspectRatioEnum) {
  updateShare(
    input: {shareId: $shareId, appearance: {cardAspectRatio: $cardAspectRatio}}
  ) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          cardAspectRatio
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCardAspectRatioMutation, UpdateShareCardAspectRatioMutationVariables>;

          

          export const useUpdateShareCardAspectRatioMutation = (options?:MutationHookOptions<UpdateShareCardAspectRatioMutation, UpdateShareCardAspectRatioMutationVariables>) => useMutation(UpdateShareCardAspectRatio, options);
          

          export type UpdateShareCardAspectRatioMutationOptions = MutationHookOptions<UpdateShareCardAspectRatioMutation, UpdateShareCardAspectRatioMutationVariables>;

          

          export type UpdateShareCardAspectRatioMutationResult = ReturnType<typeof useUpdateShareCardAspectRatioMutation>[1];

          
